import { useEffect, useRef } from "react";
import { useExpiredDataFetcher } from "../../data/expired/expiredDataLoader.ts";

export function useExpiredNotify(lastSeenExpiredAt?: string) {
  const fetcher = useExpiredDataFetcher();
  const lastCheck = useRef(lastSeenExpiredAt);
  const isValidDate = (date?: Date): date is Date =>
    !!(date && !isNaN(date.getTime()));

  useEffect(() => {
    if (
      (fetcher.state === "idle" && !fetcher.data) ||
      lastCheck.current !== lastSeenExpiredAt
    ) {
      const lastSeenExpiredAtDate = lastSeenExpiredAt
        ? new Date(lastSeenExpiredAt)
        : undefined;
      // Product/design say it's fine to only load 100 items max
      const params = new URLSearchParams();
      if (isValidDate(lastSeenExpiredAtDate)) {
        params.set("expiredAt", lastSeenExpiredAtDate.toISOString());
        params.set("cmp", "gte");
      }
      void fetcher.load(`/data/expired/1?${params.toString()}`);
      lastCheck.current = lastSeenExpiredAt;
    }
  }, [fetcher, lastSeenExpiredAt]);

  const unseenExpiredAssets =
    fetcher.data?.ok && Array.isArray(fetcher.data.data)
      ? fetcher.data.data
      : [];

  return {
    unseenExpiredCount: unseenExpiredAssets.length,
  };
}
